import React, { useState, useMemo, useEffect } from 'react';
import {Form, Input, Button, Alert} from 'antd';
import querystring from 'querystring';

import cm from '../../controllers';
import { useLocation, navigate } from '@reach/router';

const ResetPassword = ({showError, clearError}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const location = useLocation();

  useEffect(() => {
    if (location.search) {
      const {email} = querystring.parse(location.search.slice(1));
      if (email) {
        form.setFieldsValue({
          email
        })
      }
    }
  }, [location.search])
  

  return <>
    <h2 style={{
      marginTop: '10vh'
    }}>Reimposta la tua password</h2>
    <p>Inserisci la nuova password e il codice ricevuto tramite <strong>Email</strong></p>
    
    <Alert message={error} style={{
      opacity: error ? 1 : 0,
      transition: 'opacity 300ms linear',
      marginBottom: '20px'
    }} />

    <Form
      form={form}
      onFinish={async (values) => {
        try {
          setError(null)
          setLoading(true);
          await cm.controllers.auth.resetPassword(values.email, values.password, values.codice)
          navigate('/auth/login')
        } catch (e) {
          switch(e.code) {
            case "CodeMismatchException":
              setError('Il codice fornito non è valido')
              break;
            default:
              setError('Si è verificato un erorre sconosciuto');
              break;
          }
        } finally {
          setLoading(false);
        }
      }}
    >
       <Form.Item
        labelCol={{lg: 24}}
        labelAlign="left"
        wrapperCol={{lg: 24}}
        name="email"
        hasFeedback
        label="Email"
        rules={[
          {required: true, message: 'Campo necessario'},
        ]}
      > 
        <Input type="email" />
      </Form.Item>
      <Form.Item
        labelCol={{lg: 24}}
        labelAlign="left"
        wrapperCol={{lg: 24}}
        name="password"
        hasFeedback
        label="Nuova password"
        rules={[
          {required: true, message: 'Campo necessario'},
          () => ({
            validator (rule, value) {
              if (/^((?=\S*?[A-Z])(?=\S*?[a-z])(?=\S*?[0-9]).{8,})\S$/.test(value)) {
                return Promise.resolve()
              }         
              return Promise.reject('La password non soddisfa i requisiti');
            }
          })
        ]}
      > 
        <Input.Password />
      </Form.Item>
      <Form.Item
        labelCol={{lg: 24}}
        labelAlign="left"
        wrapperCol={{lg: 24}}
        name="confirm"
        label="Conferma la password"
        hasFeedback
        dependencies={['password']}
        rules={[
          {required: true, message: 'Campo necessario'},
          ({getFieldValue}) => ({
            validator (rule, value) {
              if (!value || getFieldValue('password') === value) {
                return Promise.resolve();
              }
              return Promise.reject('Le due password non coincidono');
            }
          })
        ]}
      >
        <Input.Password />
      </Form.Item>
      <Form.Item
        rules={[{required: true, message: 'Inserisci il codice di conferma'}]}
        name="codice"
        hasFeedback
        label="Codice di conferma"
      > 
        <Input />
      </Form.Item>
      <Form.Item wrapperCol={{lg: 24}} style={{textAlign: 'right'}}>
        <Button block loading={loading} type="primary" htmlType="submit">Invia</Button>
      </Form.Item>
    </Form>
  </>
};

export default ResetPassword;
